
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M12 8.40995L15.89 12.2999C16.28 12.6899 16.91 12.6899 17.3 12.2999C17.69 11.9099 17.69 11.2799 17.3 10.8899L12.71 6.29995C12.32 5.90995 11.69 5.90995 11.3 6.29995L6.7 10.8899C6.31 11.2799 6.31 11.9099 6.7 12.2999C7.09 12.6899 7.72 12.6899 8.11 12.2999L12 8.40995ZM7 17.9999H17C17.55 17.9999 18 17.5499 18 16.9999C18 16.4499 17.55 15.9999 17 15.9999H7C6.45 15.9999 6 16.4499 6 16.9999C6 17.5499 6.45 17.9999 7 17.9999Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-keyboard-capslock`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconKeyboardCapslock

    ```js
    <b-new-b-icon-keyboard-capslock />
    ```
</docs>


